export default __webpack_public_path__ + "static/media/example_1.18c1a3fd.png";